<template lang="pug">
  b-card.border-0.customerCard.tempInput(
    bg-variant="light"
  )
    .text-right.mb-2(
      v-if="deleteMode"
    )
      i.fas.fa-times-circle.fa-lg(
        @click="deleteTempHandler(originalData.id, originalData.type)"
      )
    label.w-100.mb-0(
      :for="`checkbox-group-${index}`"
    )
      .row.mb-5
        .col-2.d-flex.align-items-center.justify-content-center(
          v-show="selectMode"
        )
          b-form-checkbox(
            :id="`checkbox-group-${index}`",
            name="selectTemps",
            :checked="isChecked"
            v-show="selectMode",
            @input="selectTempHandler(originalData.id, originalData.type)",
            :class="{ 'hidden-check': isChecked }"
          )
            label.check-label(
              v-if="isChecked"
            ) {{ order + 1 }}
        .position-relative.chatBox(
          :class="{ 'col-10': selectMode, 'col-12': !selectMode }"
        )
          .chatBox__scrollBox
            .chatBox__carouselBox.d-inline-block.position-relative.w-100(
              style="white-space: nowrap;"
            )
              .carouselBox__bubble.d-inline-block.rounded.bg-white(
                v-for="(bubble,index) in originalData.push_format.bubbles",
                :class="{'w-100': originalData.push_format.bubbles.length === 1, 'mr-2': originalData.push_format.bubbles.length > 1 && originalData.push_format.bubbles.length !== index + 1}"
              )
                .bubble__upPart.position-relative.rounded-top(
                  :class="{'d-flex': !bubble.image, 'align-items-center': !bubble.image, 'justify-content-center': !bubble.image, 'no-img-min-height': !bubble.image}"
                )
                  i.fas.fa-image.fa-3x.text-muted.chatBox__imageBox-icon(
                    v-if="!bubble.image"
                  )
                  img.img-fluid.rounded-top(
                    v-else,
                    :src="bubble.image"
                  )
                .bubble__downPart.position-relative.p-2.rounded-bottom
                  span.d-block.mb-0.white-space-pre-line(
                    v-if="bubble.title === null || bubble.title === '' ",
                    :class="{ 'text-left': bubble.title_align === 'start', 'text-center': bubble.title_align === 'center', 'text-right': bubble.title_align === 'end' }", :style="{ color: bubble.title_color }")
                  span.d-block.mb-0.white-space-pre-line(
                    v-if="bubble.title !== null",
                    :class="[{'text-left': bubble.title_align === 'start', 'text-center': bubble.title_align === 'center', 'text-right': bubble.title_align === 'end' }, titleFontSize(bubble.title_size)]",
                    :style="{ color: bubble.title_color }"
                  ) {{ bubble.title }}
                  span.d-block.defaultTextColor(
                    v-if="bubble.message === null || bubble.message === '' ",
                    :class="{ 'text-left': bubble.message_align === 'start', 'text-center': bubble.message_align === 'center', 'text-right': bubble.message_align === 'end' }",
                    :style="{ color: bubble.message_color }"
                  )
                  span.d-block.defaultTextColor.white-space-pre-line(
                    v-if=" bubble.message !== null",
                    :class="{ 'text-left': bubble.message_align === 'start', 'text-center': bubble.message_align === 'center', 'text-right': bubble.message_align === 'end' }",
                    :style="{ color: bubble.message_color }"
                  ) {{ bubble.message }}
                  hr(v-if="bubble.buttons.length > 0")
                  .buttonBox.position-relative(
                    v-for="button in bubble.buttons",
                    v-if="bubble.buttons.length > 0"
                  )
                    span.text-center.d-block.pb-1(
                      v-if="button.actionType === null || button.label === null"
                    ) 動作設定
                    span.text-center.d-block.pb-1(
                      v-if="button.actionType === 'message' && button.label !== null"
                    ) {{ button.label }}
                    a.text-center.d-block.pb-1.href-text(
                      v-if="button.actionType === 'uri' && button.label !== null",
                      :href="button.uri"
                    ) {{ button.label }}
      small.font-size-sm 建立者：{{ originalData.creator }}

</template>

<script>
const _ = require('lodash');

export default {
  name: 'carousel-input',
  props: {
    index: [String, Object, Number],
    // 父層資訊
    originalData: {
      type: Object,
      required: true
    },
    selectMode: {
      type: Boolean,
      default: false
    },
    selectTemps: {
      type: Array
    },
    deleteMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectTempHandler(id, template) {
      const vm = this;
      vm.$emit('selectTempHandler', {
        id,
        template
      });
    },
    deleteTempHandler(id, template) {
      const vm = this;
      vm.$emit('deleteTempHandler', {
        id,
        template
      });
    },
    titleFontSize(size) {
      return `title-font-size-${size}`;
    }
  },
  computed: {
    isChecked() {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.id === vm.originalData.id && val.type === vm.originalData.type);
      if (key) {
        return true;
      }
        return false;
    },
    order() {
      const vm = this;
      const key = _.findKey(vm.selectTemps, (val) => val.id === vm.originalData.id && val.type === vm.originalData.type);
      return parseInt(key);
    }
  }
};
</script>

<style lang="scss" scoped>
.chatBox {
  &__scrollBox {
    overflow-x: auto;
    // 整個 scrollbar
    &::-webkit-scrollbar {
      position: absolute;
      background-color: #f3f4fa;
      border-radius: 20px;
      height: 5px;
    }
    // 裡面那條
    &::-webkit-scrollbar-thumb {
      background-color: darkgrey;
      border-radius: 10px;
    }
    /*// scroll 背景*/
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }
    .chatBox__carouselBox {
      white-space: nowrap;
      width: 100%;
      height: auto;
      // 每一個 bubble
      .carouselBox__bubble {
        width: 90%;
        height: 100%;
        white-space: normal;
        background-color: #f3f4f7;
        display: inline-block;
        vertical-align: top;
        transition: all 0.8s ease;
        // bubble 上半部
        .bubble__upPart {
          min-height: 40%;
        }
        // bubble 下半部
        .bubble__downPart {
          height: 60%;
        }
        .bubble__upPart.no-img-min-height {
          min-height: 150px;
        }
        // 訊息預設顏色
        .defaultTextColor {
          color: #858585;
        }
      }
    }
  }
}

.bg-white {
  background-color: white;
}
</style>
